import {FC, useEffect, useState} from "react";
import {PlayerFlag} from "../../../interfaces/UserInterface";
import Config from "../../../Config";
import {toast} from "react-toastify";
import {Link} from "react-router-dom";
import moment from "moment";

const Anticheat: FC = () => {
    const [ results, setResults ] = useState<PlayerFlag[]>([]);

   useEffect(() => {
        fetch(`${Config.apiUrl}/admin/v2/anticheat`, {
            mode: 'cors',
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.error)
                    toast.error(response.error);
                else
                    setResults(response);
            })
            .catch(() => toast.error(`Unknown error occurred, please try again later!`));
    }, []);

   return (
       <>
           <h1>Latest Anticheat (100 results)</h1>
           <div className={"table-head mt-6"}>
               <div className={"w-12"}>#</div>
               <div className={"w-24 mr-auto"}>User</div>
               <div className={"w-108"}>Flag <span className={"pl-1 font-normal text-sm tracking-wider opacity-50"}>(Match Id:WPM)</span></div>
               <div className={"w-52"}>Date</div>
           </div>
           {results.map((item, index) => (
               <Link to={`/search/${item.playerId}`} key={`${index}-${item.playerId}`} className={"table-item"}>
                   <div className={"w-12 font-semibold opacity-50"}>{index + 1}</div>
                   <div className={"w-24 mr-auto"}>{item.playerId}</div>
                   <div className={"w-108"}>{item.action.split('anticheat ')[1]}</div>
                   <div className={"w-52"}>{moment.unix(item.created).fromNow()}</div>
               </Link>
           ))}

       </>
   )
}

export default Anticheat;
